/*
 * TLS cart drawer: own replacement for the Upcart app.
 * - Opens after every add-to-cart (theme form, Kaching, sticky bars, other apps): fetch + XHR to /cart/add are watched.
 * - Opens on the header cart icon instead of going to /cart.
 * - Line items, totals and discounts are rendered by sections/tls-cart.liquid (Section Rendering API).
 * - Upsells (max 10, nothing that is already in the cart): first "vaak samen gekocht" from past orders (rendered by the
 *   section from metafield tls_cart.bought_together, so it shows instantly), then Shopify "related" recommendations.
 * - Adds from the drawer get the hidden line property _bron = cart-upsell:fbt | cart-upsell:related | cart-empty:...
 *   so their revenue (and which source works best) can be measured in orders.
 */
(function () {
  'use strict';
  if (window.TLSCart) return;

  var SECTION = 'tls-cart';
  var OPTOUT = '_tls_protection_optout';   // hidden cart attribute: customer switched shipping protection off
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var el = null;
  var T = {};
  var moneyFormat = '{{amount_with_comma_separator}}';
  var state = { open: false, cart: null, recCache: {}, products: {}, lastFocus: null, openTimer: null, busyCount: 0,
    stale: false,        // tab was hidden / restored from back-forward cache: state.cart may miss changes made elsewhere
    mut: 0,              // counts cart changes sent from here, so an older background read never overwrites a newer one
    protPending: null,   // the one protection add in flight (shared, never two at once)
    protFixing: false,   // a protection repair is running (one at a time, cannot loop)
    waitAdd: false };    // drawer opened from the icon while an add-to-cart was still on its way

  // ---------- helpers ----------
  function $(sel, ctx) { return (ctx || el).querySelector(sel); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function formatMoney(cents) {
    cents = Number(cents || 0);
    function delim(n, prec, th, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(dec);
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return delim(cents, 2, ',', '.');
        case 'amount_no_decimals': return delim(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(cents, 2, "'", '.');
        case 'amount_with_space_separator': return delim(cents, 2, ' ', ',');
        default: return delim(cents, 2, '.', ',');
      }
    });
  }
  function imgUrl(src, width) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + width);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }
  function pageProductId() {
    try { return window.ShopifyAnalytics.meta.product.id; } catch (e) { return null; }
  }

  // ---------- network ----------
  function postJSON(url, body) {
    return nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) {
          var e = new Error((j && (j.description || j.message)) || T.error || 'Er ging iets mis, probeer het opnieuw.');
          e.data = j;
          throw e;
        }
        return j;
      });
    });
  }
  // quiet: a background check (drawer just opened from the icon) - leave the drawer alone when nothing changed
  function fetchSection(quiet) {
    var at = state.mut;
    return nativeFetch(ROOT + '?sections=' + SECTION, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        // a cart change sent after this read brings its own, newer render: this one is outdated
        if (quiet && at !== state.mut) return;
        if (j && j[SECTION]) swap(j[SECTION], quiet);
      });
  }

  // ---------- rendering ----------
  function readCart() {
    var s = $('[data-tlsc-cart]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  // what the customer sees; the cart JSON is left out (Shopify gives its discount data a new key/timestamp on every render)
  function visibleMarkup(node) {
    var c = node.cloneNode(true);
    var s = c.querySelector('[data-tlsc-cart]');
    if (s) s.textContent = '';
    return c.innerHTML;
  }
  function swap(html, quiet) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-tlsc-live]');
    if (!fresh) return;
    var seen = visibleMarkup(fresh);
    if (quiet && seen === state.lastMarkup) {
      // nothing visible changed: only take over the fresh cart data, no redraw
      var cur = $('[data-tlsc-cart]');
      var nu = fresh.querySelector('[data-tlsc-cart]');
      if (cur && nu) cur.textContent = nu.textContent;
      state.cart = readCart() || state.cart;
      state.stale = false;
      fixProtection();
      return;
    }
    state.lastMarkup = seen;
    var live = $('[data-tlsc-live]');
    var oldUpsells = $('[data-tlsc-upsells]');
    live.innerHTML = fresh.innerHTML;
    // keep the already built carousel in place while the new one loads (no flicker)
    var mount = $('[data-tlsc-upsells]');
    if (mount && oldUpsells && oldUpsells.childNodes.length) mount.parentNode.replaceChild(oldUpsells, mount);
    state.cart = readCart();
    state.stale = false;
    if (state.cart) {
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: state.cart }, bubbles: true }));
      if (fixProtection()) return;
    }
    renderRecommendations();
  }

  // ---------- shipping protection: cart rules, checked after every render (also when nothing visible changed) ----------
  // never on its own, never more than one (also not as two separate lines: the auto and the switch add carry a
  // different _bron), and never auto-added against the customer's opt-out. Returns {line key: new qty} or null.
  function protectionFixes(cart) {
    var items = (cart && cart.items) || [];
    if (!state.protId || !items.length) return null;
    var prots = items.filter(function (i) { return String(i.product_id) === state.protId; });
    if (!prots.length) return null;
    var upd = {};
    var n = 0;
    if (prots.length === items.length) {
      prots.forEach(function (p) { upd[p.key] = 0; n++; });
      return upd;
    }
    var optOut = ((cart.attributes) || {})[OPTOUT] === '1';
    var kept = false;
    prots.forEach(function (p) {
      var auto = ((p.properties || {})._bron || '') === 'cart-addon:protection-auto';
      var want = !kept && !(optOut && auto) ? 1 : 0;
      if (want) kept = true;
      if (p.quantity !== want) { upd[p.key] = want; n++; }
    });
    return n ? upd : null;
  }
  // one repair at a time (cannot loop); a failed repair is tried once more on the next render
  function fixProtection() {
    var upd = protectionFixes(state.cart);
    if (!upd || state.protFixing) return false;
    if (state.protTries >= 2) return false;
    state.protTries = (state.protTries || 0) + 1;
    state.protFixing = true;
    function done() {
      state.protFixing = false;
      state.fixing = null;
      if (!protectionFixes(state.cart)) state.protTries = 0;
    }
    state.fixing = updateCart({ updates: upd }).then(done, done);
    return true;
  }

  // ---------- shipping protection, default on ----------
  // Added in the SAME request that renders the drawer (add.js with sections), so the drawer is drawn once.
  // assumeRealItem: right after an add-to-cart the (possibly stale) cart state may not show the new product yet.
  function needsProtection(cart, assumeRealItem) {
    if (!state.protId || !state.protDefault || !state.protVariant || state.autoAddFailed) return false;
    var items = (cart && cart.items) || [];
    var hasProt = items.some(function (i) { return String(i.product_id) === state.protId; });
    var hasReal = assumeRealItem || items.some(function (i) { return String(i.product_id) !== state.protId; });
    var optOut = ((cart && cart.attributes) || {})[OPTOUT] === '1';
    return hasReal && !hasProt && !optOut;
  }
  function addProtection() {
    if (!state.protPending) {
      state.protPending = addVariant(state.protVariant, 'cart-addon:protection-auto', true).then(function (ok) {
        state.protPending = null;
        if (!ok) state.autoAddFailed = true;   // never loop on a failing add
        return ok;
      });
    }
    return state.protPending;
  }
  function protectionItem() {
    return { id: Number(state.protVariant), quantity: 1, properties: { _bron: 'cart-addon:protection-auto' } };
  }
  // one request that brings the drawer up to date (incl. protection when needed). Only decided on state.cart when
  // that is known to be current; after a tab switch / back button it is read fresh first (opt-out made elsewhere).
  function syncCart(assumeRealItem, quiet) {
    if (!state.stale && needsProtection(state.cart, assumeRealItem)) {
      return addProtection().then(function (ok) { if (!ok) return fetchSection(quiet); });
    }
    return fetchSection(quiet).then(function () {
      // stale still true = this read was dropped for a newer cart change: that change brings its own render
      if (!state.stale && needsProtection(state.cart, false)) return addProtection();
    });
  }
  function setBusy(on) {
    state.busyCount += on ? 1 : -1;
    if (state.busyCount < 0) state.busyCount = 0;
    el.classList.toggle('is-busy', state.busyCount > 0);
  }
  function showError(msg) {
    var box = $('[data-tlsc-error]');
    box.textContent = msg;
    box.hidden = false;
    clearTimeout(showError.t);
    showError.t = setTimeout(function () { box.hidden = true; }, 6000);
  }

  // ---------- recommendations (upsells + empty state) ----------
  function recsFor(pid) {
    if (!state.recCache[pid]) {
      state.recCache[pid] = nativeFetch(ROOT + 'recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return (j && j.products) || []; })
        .catch(function () { return []; });
    }
    return state.recCache[pid];
  }
  function availableVariants(p) {
    return (p.variants || []).filter(function (v) { return v.available; });
  }
  function pricesHTML(v) {
    var out = '';
    if (v.compare_at_price && v.compare_at_price > v.price) out += '<s>' + esc(formatMoney(v.compare_at_price)) + '</s>';
    return out + '<span>' + esc(formatMoney(v.price)) + '</span>';
  }
  function tileHTML(p) {
    var vs = availableVariants(p);
    var v = vs[0];
    state.products[p.id] = p;
    var url = p.url || ('/products/' + p.handle);
    var img = imgUrl((v.featured_image && v.featured_image.src) || p.featured_image, 200);
    var select = '';
    if (p.variants.length > 1) {
      select = '<select class="tlsc-up__select" data-tlsc-variant aria-label="' + esc(p.title) + '">' +
        vs.map(function (x) { return '<option value="' + x.id + '">' + esc(x.title) + '</option>'; }).join('') +
        '</select>';
    }
    return '<div class="tlsc-up" data-tlsc-product="' + p.id + '" data-tlsc-src="' + esc(p._src || 'related') + '">' +
      '<a class="tlsc-up__img" href="' + esc(url) + '"><img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="80" height="80"></a>' +
      '<div class="tlsc-up__main">' +
        '<a class="tlsc-up__title" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
        '<div class="tlsc-up__prices" data-tlsc-prices>' + pricesHTML(v) + '</div>' +
        '<div class="tlsc-up__row">' + select +
          '<button type="button" class="tlsc-up__add" data-tlsc-add="' + v.id + '">' + esc(T.add) + '</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }
  var ARROW_L = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ARROW_R = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function buildCarousel(mount, products) {
    if (!products.length) { mount.innerHTML = ''; return; }
    var many = products.length > 1;
    mount.innerHTML = '<div class="tlsc-car">' +
      (many ? '<button type="button" class="tlsc-car__arrow tlsc-car__arrow--prev" data-tlsc-car="-1" aria-label="' + esc(T.prev) + '">' + ARROW_L + '</button>' : '') +
      '<div class="tlsc-car__track" data-tlsc-track>' + products.map(tileHTML).join('') + '</div>' +
      (many ? '<button type="button" class="tlsc-car__arrow tlsc-car__arrow--next" data-tlsc-car="1" aria-label="' + esc(T.next) + '">' + ARROW_R + '</button>' : '') +
      '</div>';
  }
  function buildList(mount, products) {
    mount.innerHTML = products.map(tileHTML).join('');
  }
  function readJSON(sel) {
    var s = $(sel);
    if (!s) return [];
    try { return JSON.parse(s.textContent) || []; } catch (e) { return []; }
  }
  function fallbackProducts() { return readJSON('[data-tlsc-fallback]'); }
  function carouselIds(mount) {
    return Array.prototype.map.call(mount.querySelectorAll('[data-tlsc-product]'), function (t) {
      return t.getAttribute('data-tlsc-product');
    });
  }
  // Show `list` in the carousel. If the carousel already starts with the same products, only append the rest,
  // so a customer who is already swiping is never thrown back to the first tile.
  function showCarousel(mount, list) {
    var have = carouselIds(mount);
    var want = list.map(function (p) { return String(p.id); });
    var samePrefix = have.length > 1 && have.every(function (id, i) { return want[i] === id; });
    if (samePrefix && want.length >= have.length) {
      var track = mount.querySelector('[data-tlsc-track]');
      list.slice(have.length).forEach(function (p) { track.insertAdjacentHTML('beforeend', tileHTML(p)); });
      return;
    }
    if (have.join() !== want.join()) buildCarousel(mount, list);
  }
  function renderRecommendations() {
    var cart = state.cart;
    var mount = $('[data-tlsc-upsells]');
    var emptyMount = $('[data-tlsc-empty-recs]');
    if (cart && cart.item_count > 0 && mount) {
      var inCart = {};
      var pids = [];
      if (state.protId) inCart[state.protId] = true;
      cart.items.forEach(function (i) {
        inCart[i.product_id] = true;
        if (pids.indexOf(i.product_id) < 0 && String(i.product_id) !== state.protId) pids.push(i.product_id);
      });
      // drop tiles of products that are now in the cart right away (e.g. the upsell that was just added)
      Array.prototype.forEach.call(mount.querySelectorAll('[data-tlsc-product]'), function (t) {
        if (inCart[t.getAttribute('data-tlsc-product')]) t.parentNode.removeChild(t);
      });
      var seen = {};
      var out = [];
      function take(p) {
        if (out.length >= 10 || seen[p.id] || inCart[p.id] || !availableVariants(p).length) return;
        seen[p.id] = true;
        out.push(p);
      }
      // 1) "vaak samen gekocht" from past orders: already in the section HTML, so it shows instantly
      readJSON('[data-tlsc-fbt]').forEach(take);
      if (out.length) showCarousel(mount, out.slice());
      // 2) top up with Shopify's related recommendations (fetched once per product, then cached)
      var token = (renderRecommendations.token = (renderRecommendations.token || 0) + 1);
      Promise.all(pids.slice(0, 4).map(recsFor)).then(function (lists) {
        if (token !== renderRecommendations.token) return;
        lists.forEach(function (list) { list.forEach(take); });
        var target = $('[data-tlsc-upsells]');
        if (!target) return;
        if (out.length) showCarousel(target, out);
        else target.innerHTML = '';
      });
    } else if (emptyMount) {
      var pid = pageProductId();
      var source = pid ? recsFor(pid) : Promise.resolve(fallbackProducts());
      source.then(function (list) {
        if (!list.length && pid) list = fallbackProducts();
        var target = $('[data-tlsc-empty-recs]');
        if (target) buildList(target, list.filter(function (p) {
          return availableVariants(p).length && String(p.id) !== state.protId;
        }).slice(0, 3));
      });
    }
  }

  // ---------- cart actions ----------
  function changeLine(key, qty) {
    setBusy(true);
    state.mut++;
    return postJSON(ROOT + 'cart/change.js', { id: key, quantity: Math.max(0, qty), sections: SECTION })
      .then(function (j) {
        if (j.sections && j.sections[SECTION]) swap(j.sections[SECTION]);
        else return fetchSection();
      })
      .catch(function (e) { showError(e.message); return fetchSection().catch(function () { /* offline */ }); })
      .then(function () { setBusy(false); signal(); });
  }
  function addVariant(id, source, silent) {
    setBusy(true);
    state.mut++;
    var ok = true;
    var items = [{ id: Number(id), quantity: 1, properties: { _bron: source || 'cart-upsell:related' } }];
    // a product added from the drawer itself (e.g. the empty state): protection goes along in the same request
    var real = String(id) !== state.protVariant;
    var stale = state.stale;
    var withProt = real && !stale && !state.protPending && needsProtection(state.cart, true);
    if (withProt) items.push(protectionItem());
    function send(list) { return postJSON(ROOT + 'cart/add.js', { items: list, sections: SECTION }); }
    return send(items)
      .catch(function (e) {
        if (!withProt) throw e;
        // protection could not be added: the customer's product still goes in, on its own
        return send(items.slice(0, 1)).then(function (j) { state.autoAddFailed = true; return j; });
      })
      .then(function (j) {
        if (j.sections && j.sections[SECTION]) swap(j.sections[SECTION]);
        else return fetchSection();
      })
      // decided after the fresh render when the cart state was not current before the add
      .then(function () { if (real && stale && needsProtection(state.cart, false)) return addProtection(); })
      .catch(function (e) { ok = false; if (!silent) showError(e.message); })
      .then(function () { setBusy(false); signal(); return ok; });
  }
  function updateCart(body) {
    setBusy(true);
    state.mut++;
    body.sections = SECTION;
    return postJSON(ROOT + 'cart/update.js', body)
      .then(function (j) {
        if (j.sections && j.sections[SECTION]) swap(j.sections[SECTION]);
        else return fetchSection();
      })
      .catch(function (e) { showError(e.message); return fetchSection().catch(function () { /* offline */ }); })
      .then(function () { setBusy(false); signal(); });
  }
  // tell the shop's other open tabs that the cart changed (they read it fresh before their next decision)
  function signal() {
    try { localStorage.setItem('tlsc-cart-changed', String(Date.now())); } catch (e) { /* private mode */ }
  }

  // ---------- open / close ----------
  function open() {
    if (!el || state.open) return;
    state.open = true;
    state.lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tlsc-lock');
    setTimeout(function () {
      var c = $('.tlsc__close');
      if (c) { try { c.focus({ preventScroll: true }); } catch (e) { c.focus(); } }
    }, 60);
  }
  function close() {
    if (!el || !state.open) return;
    state.open = false;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tlsc-lock');
    if (state.onCartPage) { window.location.href = ROOT; return; }
    if (state.lastFocus && state.lastFocus.focus) { try { state.lastFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
  }
  // After an add-to-cart: first bring the drawer fully up to date (new product + shipping protection in one request),
  // then slide it in once - no stale content first, no second redraw. On a slow connection it opens after 1.2 s anyway.
  function adding(on) { document.documentElement.classList.toggle('tlsc-adding', on); }
  function openAfterAdd() {
    var shown = false;
    var slow = setTimeout(function () { shown = true; adding(false); open(); setBusy(true); }, 1200);
    return syncCart(true).catch(function () { /* show what we have */ })
      .then(function () { return state.fixing; })   // a running protection repair finishes before the drawer shows
      .catch(function () { /* show what we have */ })
      .then(function () {
        clearTimeout(slow);
        adding(false);
        if (shown) setBusy(false);
        else open();
        stopWaiting();
      });
  }
  // Cart icon, /cart page, TLSCart.open(): the drawer as rendered with the page is shown right away and checked
  // quietly in the background (other tab, back button) - it is only redrawn when something actually changed.
  function openNow() {
    renderRecommendations();
    open();
    if (document.documentElement.classList.contains('tlsc-adding')) {
      // an add-to-cart is still on its way: wait for it (openAfterAdd brings the drawer up to date), no second sync
      if (!state.waitAdd) { state.waitAdd = true; setBusy(true); }
      return Promise.resolve();
    }
    return syncCart(false, true).catch(function () { /* keep what we have */ });
  }
  function stopWaiting() {
    if (!state.waitAdd) return;
    state.waitAdd = false;
    setBusy(false);
  }
  // the add-to-cart failed (or never answered): undo the waiting state and show the cart as it is
  function addFailed() {
    adding(false);
    if (state.waitAdd) { stopWaiting(); fetchSection(true).catch(function () { /* keep what we have */ }); }
  }
  function scheduleOpen() {
    clearTimeout(state.openTimer);
    state.openTimer = setTimeout(openAfterAdd, 60);
  }

  // ---------- add-to-cart detection (same approach as Upcart) ----------
  function isAddUrl(url) {
    return /\/cart\/add(\.js|\.json)?(\?|$)/.test(String(url || ''));
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (isAddUrl(url)) {
      adding(true);   // from the click until the drawer is open: add buttons dimmed (also the sticky bar's)
      state.mut++;
      p.then(function (r) { if (r && r.ok) { signal(); scheduleOpen(); } else addFailed(); }).catch(addFailed);
    }
    return p;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__tlscAdd = isAddUrl(url);
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__tlscAdd) {
      adding(true);
      state.mut++;
      this.addEventListener('loadend', function () {
        if (this.status >= 200 && this.status < 300) { signal(); scheduleOpen(); }
        else addFailed();
      });
    }
    return xhrSend.apply(this, arguments);
  };

  // The theme shows a small "added" popdown after add-to-cart; we open the drawer instead.
  window.addEventListener('theme:cart:popdown', function (e) { e.stopImmediatePropagation(); }, true);

  // Header cart icon / any link to /cart opens the drawer.
  document.addEventListener('click', function (e) {
    if (!el || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target && e.target.closest ? e.target.closest('[data-drawer-toggle="drawer-cart"], a[href="/cart"], a[href$="/cart"]') : null;
    if (!t || el.contains(t)) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    openNow();
  }, true);

  // ---------- events inside the drawer ----------
  function bindDrawer() {
    el.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-tlsc-close]')) { e.preventDefault(); close(); return; }

      var setBtn = t.closest('[data-tlsc-set]');
      if (setBtn) {
        var item = setBtn.closest('[data-key]');
        if (item) changeLine(item.getAttribute('data-key'), parseInt(setBtn.getAttribute('data-tlsc-set'), 10));
        return;
      }

      var add = t.closest('[data-tlsc-add]');
      if (add) {
        var tileEl = add.closest('[data-tlsc-product]');
        var where = add.closest('[data-tlsc-empty-recs]') ? 'cart-empty' : 'cart-upsell';
        addVariant(add.getAttribute('data-tlsc-add'), where + ':' + ((tileEl && tileEl.getAttribute('data-tlsc-src')) || 'related'));
        return;
      }

      var arrow = t.closest('[data-tlsc-car]');
      if (arrow) {
        var track = arrow.parentNode.querySelector('[data-tlsc-track]');
        var dir = parseInt(arrow.getAttribute('data-tlsc-car'), 10);
        var max = track.scrollWidth - track.clientWidth;
        var next = track.scrollLeft + dir * track.clientWidth;
        if (next > max + 2) next = 0;
        if (next < -2) next = max;
        track.scrollTo({ left: next, behavior: 'smooth' });
      }
    });
    el.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-tlsc-protection]')) {
        var attrs = {};
        if (t.checked) {
          attrs[OPTOUT] = '';
          // clear the opt-out without redrawing, then one add that redraws the drawer
          setBusy(true);
          state.mut++;
          postJSON(ROOT + 'cart/update.js', { attributes: attrs })
            .catch(function () { /* still add it */ })
            .then(function () { return addVariant(t.getAttribute('data-variant'), 'cart-addon:protection'); })
            .then(function () { setBusy(false); });
        } else if (t.getAttribute('data-key')) {
          // off = every protection line out (an older cart can hold two), remembered for this cart: never re-added
          var upd = {};
          upd[t.getAttribute('data-key')] = 0;
          ((state.cart && state.cart.items) || []).forEach(function (i) {
            if (String(i.product_id) === state.protId) upd[i.key] = 0;
          });
          attrs[OPTOUT] = '1';
          updateCart({ updates: upd, attributes: attrs });
        }
        return;
      }
      if (t.matches('[data-tlsc-qty-input]')) {
        var item = t.closest('[data-key]');
        var q = parseInt(t.value, 10);
        if (item && !isNaN(q)) changeLine(item.getAttribute('data-key'), q);
        return;
      }
      if (t.matches('[data-tlsc-variant]')) {
        var tile = t.closest('[data-tlsc-product]');
        var p = state.products[tile.getAttribute('data-tlsc-product')];
        var v = p && p.variants.filter(function (x) { return String(x.id) === t.value; })[0];
        if (!v) return;
        tile.querySelector('[data-tlsc-add]').setAttribute('data-tlsc-add', v.id);
        tile.querySelector('[data-tlsc-prices]').innerHTML = pricesHTML(v);
        var src = (v.featured_image && v.featured_image.src) || p.featured_image;
        if (src) tile.querySelector('.tlsc-up__img img').src = imgUrl(src, 200);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.open) close();
    });
  }

  function init() {
    el = document.getElementById('tls-cart');
    if (!el) return;
    if (el.parentNode !== document.body) document.body.appendChild(el.closest('.shopify-section') || el);
    moneyFormat = el.getAttribute('data-money-format') || moneyFormat;
    state.protId = el.getAttribute('data-protection-id') || '';
    state.protVariant = el.getAttribute('data-protection-variant') || '';
    state.protDefault = el.getAttribute('data-protection-default') === 'true';
    T = {
      add: el.getAttribute('data-t-add') || 'Toevoegen',
      prev: el.getAttribute('data-t-prev') || '',
      next: el.getAttribute('data-t-next') || '',
      error: el.getAttribute('data-t-error') || 'Er ging iets mis, probeer het opnieuw.'
    };
    state.cart = readCart();
    var live = $('[data-tlsc-live]');
    state.lastMarkup = live ? visibleMarkup(live) : '';
    bindDrawer();
    // the cart may change elsewhere (other tab, back button restores an old page): read it again when the page is
    // shown again, and until then never decide on the old copy. A page that loaded in a background tab or came
    // from Back starts out unverified.
    var nav = (window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    state.stale = document.visibilityState !== 'visible' || nav.type === 'back_forward';
    if (state.stale && !document.hidden) fetchSection(true).catch(function () { /* next action reads it fresh */ });
    window.addEventListener('storage', function (e) {
      if (e.key !== 'tlsc-cart-changed') return;
      state.stale = true;
      if (!document.hidden) fetchSection(true).catch(function () { /* next action reads it fresh */ });
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { state.stale = true; return; }
      if (state.stale) fetchSection(true).catch(function () { /* next action reads it fresh */ });
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      state.stale = true;
      adding(false);
      fetchSection(true).catch(function () { /* next action reads it fresh */ });
    });
    // repair carts left with a double / orphan protection by older versions of this drawer
    fixProtection();
    // recommendations are loaded on first open (every open re-renders the section), not on every page view

    // the early inline click catcher (layout) hands over from here on
    window.__tlscReady = true;
    // on the theme's /cart page (back-from-checkout link, reminder mails, very early icon click): show the drawer
    // instead of the plain cart page; closing it continues shopping on the homepage
    state.onCartPage = document.body.classList.contains('template-cart');
    if (state.onCartPage || window.__tlscOpen) {
      window.__tlscOpen = false;
      openNow();
    }
  }

  window.TLSCart = { open: openNow, close: close, refresh: fetchSection };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
